import { Component, OnDestroy, OnInit, TemplateRef, viewChild, inject } from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {DataService} from "../../services/data.service";
import {ToastrService} from "ngx-toastr";
import {AccessService} from "../../services/access.service";
import {BreadcrumbsComponent} from "../../breadcrumbs/breadcrumbs.component";
import {BreadcrumbsService} from "../../services/breadcrumbs.service";
import {Subscription} from "rxjs";
import {BsModalService, BsModalRef, ModalModule, ModalDirective} from 'ngx-bootstrap/modal';
import Swal from "sweetalert2";
import {FileItem, FileUploader, FileUploadModule} from "ng2-file-upload";
import {environment} from "../../../environments/environment";
import moment from "moment";
import {DomSanitizer} from "@angular/platform-browser";
import {FileTypePipe} from "../../pipes/file-type.pipe";
import {TooltipDirective} from "ngx-bootstrap/tooltip";
import {FileSizePipe} from "../../pipes/file-size.pipe";
import {AdminNavigationComponent} from "../admin-navigation/admin-navigation.component";
import {AccordionComponent, AccordionPanelComponent} from "ngx-bootstrap/accordion";

@Component({
    selector: 'app-admin-list',
    imports: [
        CommonModule, FormsModule, BreadcrumbsComponent, FileUploadModule, ModalModule, FileTypePipe,
        TooltipDirective, FileSizePipe, AdminNavigationComponent, AccordionComponent, AccordionPanelComponent
    ],
    templateUrl: './admin-list.component.html',
    styleUrl: './admin-list.component.scss'
})
export class AdminListComponent implements OnInit, OnDestroy {

    accessService = inject(AccessService);
    breadcrumbsService = inject(BreadcrumbsService);
    private route = inject(ActivatedRoute);
    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);
    private modalService = inject(BsModalService);
    private sanitizer = inject(DomSanitizer);

    folderDetail = viewChild.required<ModalDirective>('folderDetail');
    fileDetail = viewChild.required<ModalDirective>('fileDetail');
    linkDetail = viewChild.required<ModalDirective>('linkDetail');

    folderModalRef?: BsModalRef;
    linkModalRef?: BsModalRef;

    environment = environment;

    uploader!: FileUploader;
    hasBaseDropZoneOver = false;
    uploadResponses: any[] = [];

    slug!: string|null|undefined;

    private openFolder$!: Subscription;
    stats: any;
    currentFolder: string|null = null;
    elements!: any[];

    newFolder: any = {
        name: '',
        qrcode: true,
        number: '',
    };
    newLink: any = {
        name: '',
        qrcode: true,
        number: '',
        url: '',
    }
    openedElement: any;
    openedTab: string = 'details';

    today: any;
    embedString: any = null;
    selectedElements: any = [];

    availableNumbers: any[] = [];
    assigningCode = false;

    predicate = 'name';
    reverse = false;

    ngOnInit(): void {
        this.today = moment().format("YYYY-MM-DD");

        this.slug = this.route.parent?.snapshot.paramMap.get('slug');

        // list to breadcrumbs events
        this.openFolder$ = this.breadcrumbsService.openFolder.subscribe(id => {
            this.currentFolder = id;
            this.getFolder();
        });

        this.getStats();
        this.getFolder();
        this.initUploader();
    }

    ngOnDestroy() {
        this.openFolder$?.unsubscribe();
    }

    initUploader() {
        this.uploader = new FileUploader({
            url: "api/api.php",
            authToken: this.accessService.token,
            itemAlias: 'files',
            additionalParameter: {
                apiController: 'File/upload',
            },
            filters: [
                {
                    name: 'sizeFilter',
                    fn: function (item) {
                        return item.size < (1024 * 1024 * 300); // 300 MB
                    }
                },
                {
                    name: 'typeFilter',
                    fn: function (item) {
                        return item.type == 'application/pdf'
                    }
                }
            ],
        });

        this.uploader.onAfterAddingFile = ((fileItem: FileItem) => {
            fileItem.formData.name = fileItem.file.name?.substring(0, fileItem.file.name.lastIndexOf('.')) || fileItem.file.name;
            fileItem.formData.name = fileItem.formData.name.replace(/_/g, ' ');
        });

        this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('name', fileItem.formData.name);
            form.append('id_folder', this.currentFolder);
        };

        this.uploader.response.subscribe(res => {
            this.uploadResponses.push(JSON.parse(res));
            this.getStats();
            this.getFolder();
        });
    }

    getStats() {
        this.dataService.request('Client/getStats').subscribe(response => {
            this.stats = response.stats;
        });
    }

    getFolder() {
        this.dataService.request('Folder/get', {
            id_folder: this.currentFolder,
        }).subscribe(response => {
            this.elements = response.elements;

            this.elements.forEach(element => {
                if (element.type == 'file') {
                    element.size = parseInt(element.size) / 1024 / 1024; // KB
                }

                if (element.codes.length > 0) {
                    element.codesString = element.codes.map((code: any) => this.slug?.toUpperCase() + '-' + code.number).join(', ');
                }
            })
        });
    }

    openFolderModal(template: TemplateRef<any>) {
        this.folderModalRef = this.modalService.show(template);

        this.dataService.request("Code/getAvailable").subscribe(response => {
            this.availableNumbers = response.availableNumbers;
        })

        this.newFolder = {
            name: '',
            qrcode: true,
            number: '',
        };
    }

    openLinkModal(template: TemplateRef<any>) {
        this.linkModalRef = this.modalService.show(template);

        this.dataService.request("Code/getAvailable").subscribe(response => {
            this.availableNumbers = response.availableNumbers;
        })

        this.newLink = {
            name: '',
            qrcode: true,
            number: '',
            url: '',
        };
    }

    saveFolder(ref: any) {
        this.dataService.request('Folder/save', {
            name: this.newFolder.name,
            qrcode: this.newFolder.qrcode,
            number: this.newFolder.number,
            id_folder: this.currentFolder,
        }).subscribe(response => {
            if (response.error) {
                this.toastrService.error(response.error, 'Fehler');
            } else {
                ref.hide();
                this.toastrService.success('Ordner angelegt', 'Erfolg');

                this.getFolder();
                this.getStats();
            }
        });
    }

    saveLink(ref: any) {
        this.dataService.request('Link/save', {
            name: this.newLink.name,
            url: this.newLink.url,
            qrcode: this.newLink.qrcode,
            number: this.newLink.number,
            id_folder: this.currentFolder,
        }).subscribe(response => {
            if (response.error) {
                this.toastrService.error(response.error, 'Fehler');
            } else {
                ref.hide();
                this.toastrService.success('Link angelegt', 'Erfolg');

                this.getFolder();
                this.getStats();
            }
        });
    }

    stackFolder(folder: any) {
        this.breadcrumbsService.stackFolder.next({
            title: folder.name,
            id: folder.id
        });
        this.currentFolder = folder.id;
        this.getFolder();
    }

    deleteFolder(folder: any) {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Ordner wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Folder/delete', {
                    id: folder.id,
                }).subscribe(response => {
                    this.toastrService.success('Ordner gelöscht', 'Erfolg');
                    this.getStats();
                    this.getFolder();
                });
            }
        });
    }

    deleteElements(ids: any[]) {
        const fileIDs = ids.filter(element => element.type == 'file');
        this.deleteFile(fileIDs);

        const linkIDs = ids.filter(element => element.type == 'link');
        this.deleteLink(linkIDs);
    }

    deleteFile(ids: any[]) {
        Swal.fire({
            title: 'Sicher?',
            text: ids.length == 1 ? 'Die Datei wird gelöscht.' : 'Die Dateien werden gelöscht',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('File/deleteMultiple', {
                    ids: ids,
                }).subscribe(response => {
                    this.toastrService.success('Datei(en) gelöscht', 'Erfolg');
                    this.getStats();
                    this.getFolder();
                    this.selectedElements = [];
                });
            }
        });
    }

    deleteLink(ids: any[]) {
        Swal.fire({
            title: 'Sicher?',
            text: ids.length == 1 ? 'Der Link wird gelöscht.' : 'Die Links werden gelöscht',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Link/deleteMultiple', {
                    ids: ids,
                }).subscribe(response => {
                    this.toastrService.success('Link(s) gelöscht', 'Erfolg');
                    this.getStats();
                    this.getFolder();
                    this.selectedElements = [];
                });
            }
        });
    }

    fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    clearResponses() {
        this.uploadResponses = [];
    }

    selectFolder(element: any) {
        this.dataService.request('Folder/getDetails', {
            hash: element.hash,
        }).subscribe(response => {
            this.openedElement = response.folder;

            this.openedTab = 'details';
            this.folderDetail().show();
        })
    }

    selectFile(element: any) {
        this.dataService.request('File/getDetails', {
            hash: element.hash,
        }).subscribe(response => {
            response.file.size = parseInt(response.file.size) / 1024 / 1024; // KB
            this.openedElement = response.file;

            this.openedTab = 'details';
            this.fileDetail().show();
        })
    }

    selectLink(element: any) {
        this.dataService.request('Link/getDetails', {
            hash: element.hash,
        }).subscribe(response => {
            this.openedElement = response.link;

            this.openedTab = 'details';
            this.linkDetail().show();
        })
    }

    closeFolder() {
        this.openedElement = null;
        this.assigningCode = false;
        this.folderDetail().hide();
    }

    closeFile() {
        this.openedElement = null;
        this.assigningCode = false;
        this.fileDetail().hide();
    }

    closeLink() {
        this.openedElement = null;
        this.assigningCode = false;
        this.linkDetail().hide();
    }

    updateFolder() {
        this.dataService.request('Folder/update', {
            folder: this.openedElement
        }).subscribe(response => {
            this.closeFolder();
            this.toastrService.success('Ordner wurde aktualisiert', 'Erfolg');
            this.getFolder();
            this.getStats();

            this.assigningCode = false;
        })
    }

    updateFile() {
        this.dataService.request('File/update', {
            file: this.openedElement
        }).subscribe(response => {
            this.closeFile();
            this.toastrService.success('Dokument wurde aktualisiert', 'Erfolg');
            this.getFolder();
            this.getStats();

            this.assigningCode = false;
        })
    }

    updateLink() {
        this.dataService.request('Link/update', {
            link: this.openedElement
        }).subscribe(response => {
            this.closeLink();
            this.toastrService.success('Link wurde aktualisiert', 'Erfolg');
            this.getFolder();
            this.getStats();

            this.assigningCode = false;
        })
    }

    setOpenedTab(event: MouseEvent, openedTab: string) {
        event.preventDefault();

        this.openedTab = openedTab;

        if (this.openedTab == 'preview') {
            this.dataService.request('File/getFileData', {
                hash: this.openedElement.hash,
            }).subscribe(response => {
                const byteCharacters = atob(response.data.data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const file = new Blob([byteArray], { type: 'application/pdf;base64' });
                this.embedString = URL.createObjectURL(file);
                this.embedString = this.sanitizer.bypassSecurityTrustResourceUrl(this.embedString);
            });
        }
    }

    deleteMetaDataItem(data: any) {
        this.openedElement.metadata.splice(this.openedElement.metadata.indexOf(data), 1);
    }

    addMetaDataItem() {
        this.openedElement.metadata.push({key: '', value: ''});
    }

    printCode() {
        window.print();
    }

    openCode(code: any) {
        const title = (this.slug + '-' + (code.number || code.codeNumber)).toUpperCase();
        const newWindow = window.open();
        newWindow?.document.write('<html><head><title>' + title + '</title></head><body style="margin: 0;"><img src="' + code.qrdata + '" style="width: 100%" alt="QR Code"/></body></html>');
        newWindow?.document.close();
    }

    updateSelectedElements() {
        this.selectedElements = this.elements.filter(element => element.selected).map(element => element.id);
    }

    exportExcel() {
        this.dataService.request('File/exportExcel').subscribe((response: any) => {
            if (response.error) {
                this.toastrService.error(response.error, "Fehler");
            } else {
                this.toastrService.success('Excel Datei wurde erstellt', "Erfolg");

                const link = document.createElement('a');

                link.setAttribute('href', 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + response.data.data);
                link.setAttribute('download', response.data.name);
                link.click();
            }
        });
    }

    setAvailableNumber(type: string, number: any) {
        if (type == 'folder') this.newFolder.number = number;
        if (type == 'link') this.newLink.number = number;
    }

    unassignCode(code: any) {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Zuweisung wird entfernt.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request("Code/unassign", {
                    number: code.codeNumber,
                }).subscribe(response => {
                    this.openedElement.codes.splice(this.openedElement.codes.indexOf(code), 1);

                    this.getStats();
                })
            }
        });
    }

    assignCode() {
        this.assigningCode = true;
        this.openedElement.assignedNumber = '';

        this.dataService.request("Code/getAvailable").subscribe(response => {
            this.availableNumbers = response.availableNumbers;
        })
    }

    cancelAssignCode() {
        this.assigningCode = false;
        this.openedElement.assignedNumber = '';
    }

    setAvailableNumberForExisting(number: any) {
        this.openedElement.assignedNumber = number;
    }

    moveUp() {
        this.breadcrumbsService.moveUpFolder.next(true);
    }

    sortTable(predicate: string) {
        this.predicate = predicate;

        this.reverse = !this.reverse;

        // sort elements by given column
        this.elements.sort((a, b) => {
            // workaround for folder which has no size but only count of children
            if (!a[predicate] || !b[predicate]) return 0;

            if (a[predicate] < b[predicate]) {
                return -1;
            }
            if (a[predicate] > b[predicate]) {
                return 1;
            }
            return 0;
        });

        if (this.reverse || this.predicate == 'size') {
            this.elements.reverse();
        }
    }
}
